import _ from "lodash";
import Indicador from "..";
import DCorEditFields from "./components/DCorEditFields";
import { DCorParamFields } from "./components/DCorParamFields";
import dcorReport from "./reports";
import dcorReportSummary from "./reports/summary";

export default class DCor extends Indicador {
    static get fullName() {
        return "Distribuição de Corretivo";
    }

    static get abbrev() {
        return "DCor";
    }

    // static get multTipo() {
    //     return true
    // }

    getAverage(visita, field, tipoName, params) { // pdf da visita ou pdf do laudo
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName)

        if (!_.isEmpty(apontamentos)) {
            if (field === "conformidade") {
                let qtdConforme = 0
                let qtdNaoConforme = 0

                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        if (coleta.conforme === "Sim") {
                            qtdConforme++
                        } else {
                            qtdNaoConforme++
                        }
                    }
                })
                const total = qtdConforme + qtdNaoConforme
                if (!total) {
                    return 0
                }

                return (qtdConforme * 100) / total
            }

            if (field === "conformeEsquerda") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeEsquerda
                    }
                })

                return conformidade
            }

            if (field === "conformeCentro") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeCentro
                    }
                })

                return conformidade
            }

            if (field === "conformeDireita") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeDireita
                    }
                })

                return conformidade
            }
        }

        return 0
    }

    static paramFields(tipoIndicadorField = '') {
        return <DCorParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <DCorEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return dcorReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return dcorReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat
        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;

        let qtdAcima = 0 // nº de coletas acima da meta
        let sumAcima = 0 // soma das coletas acima da meta

        let qtdAbaixo = 0 // nº de coletas abaixo da meta
        let sumAbaixo = 0 // soma das coletas abaixo da meta

        let mediaConformidade = 0

        const dose = apontamento.dosagemRecomendada ?? 0
        const bandejas = apontamento.qtdBandejas ?? 0

        for (const coleta of apontamento.coletas) {
            const largura = params.largura ?? 0
            const centro = coleta.centro ?? 0
            const direita = coleta.direita ?? 0
            const esquerda = coleta.esquerda ?? 0
            const comprimento = params.comprimento ?? 0
            const areaTalhao = params.areaHa ?? 0
            // const meta = params.meta ?? 0

            const calculoConformidade = dose * (bandejas * (largura * comprimento)) / areaTalhao

            const conformeCentro = ((f(centro) / calculoConformidade) * 100)
            const conformeDireita = ((f(direita) / calculoConformidade) * 100)
            const conformeEsquerda = ((f(esquerda) / calculoConformidade) * 100)

            mediaConformidade = (f(conformeCentro) + f(conformeDireita) + f(conformeEsquerda)) / 3

            let min = parseFloat(params.intervaloMin)
            let max = parseFloat(params.intervaloMax)

            if (conformeCentro > (max + 15) || conformeCentro < (min - 15)) {
                coleta.conformeCen = "Não"
            } else {
                coleta.conformeCen = "Sim"
            }

            if (conformeDireita > (max + 15) || conformeDireita < (min - 15)) {
                coleta.conformeDir = "Não"
            } else {
                coleta.conformeDir = "Sim"
            }

            if (conformeEsquerda > (max + 15) || conformeEsquerda < (min - 15)) {
                coleta.conformeEsq = "Não"
            } else {
                coleta.conformeEsq = "Sim"
            }

            coleta.conformeDireita = conformeDireita
            coleta.conformeEsquerda = conformeEsquerda
            coleta.conformeCentro = conformeCentro
            coleta.mediaConformidade = mediaConformidade
            coleta.acima = mediaConformidade > (max + 15) ? 1 : 0
            coleta.abaixo = mediaConformidade < (min - 15) ? 1 : 0
        }

        apontamento.qtdAcima = qtdAcima

        if (qtdAcima > 0) {
            apontamento.percentAcima = (qtdAcima * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAcima = (sumAcima / qtdAcima)
            apontamento.sumAcima = sumAcima
        } else {
            apontamento.mediaAcima = 0
        }

        apontamento.qtdAbaixo = qtdAbaixo

        if (qtdAbaixo > 0) {
            apontamento.percentAbaixo = (qtdAbaixo * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAbaixo = (sumAbaixo / qtdAbaixo)
            apontamento.sumAbaixo = sumAbaixo
        } else {
            apontamento.mediaAbaixo = 0
        }

        apontamento.qtdConforme = conformeCount

        return mediaConformidade.toFixed(2)
    }

    static getConformidadeStatus(conformidade, meta, apontamento, cliente, type, tipoName) {

        if (!cliente) {
            throw new Error(
                "Este indicador necessita dos dados do cliente para calcular o status de conformidade"
            )
        }

        let cliParam
        if (cliente.getAllParams) {
            cliParam = cliente.getAllParams(this, type)
        } else if (cliente.params) {
            cliParam = _.get(cliente.params, (this.abbrev + type.field).toLowerCase())
        }

        let itensStatus = _.get(cliParam, (tipoName ? tipoName.toLowerCase() + "." : "") + "items")
        let min = parseFloat(cliParam?.mecanizado?.intervaloMin)
        let max = parseFloat(cliParam?.mecanizado?.intervaloMax)

        if (!itensStatus) {
            return this.calcConformidadeStatusDCor(conformidade, min, max);
        }

        return this.calcConformidadeStatusDCor(conformidade, min, max);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.espacamento)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Espaçamento", width: 'auto', getValue: (a) => {
                    let sum = 0
                    let arr = a.coletas.map(x => {
                        if (x.espacamento) {
                            sum = sum + parseFloat(x.espacamento)
                            return x.espacamento
                        } else {
                            return 0
                        }

                    })
                    if (sum) {
                        return (sum / arr.length).toFixed(2)
                    } else {
                        return '0'
                    }
                }
            },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Dosagem Recomendada: " + apontamento.dosagemRecomendada
            + ", Quant. Bandejas: " + apontamento.qtdBandejas
    }
}
